import React from "react";
import bemember from "../../../assets/images/ncc/bemember.jpg";
const BeMember = () => {
  return (
    <section className="relative overflow-hidden bg-gray-100">
      <img
        className="absolute top-0 h-full w-full object-cover object-center opacity-60"
        src={bemember}
      />

      <div className="bg-white/60 relative mx-auto flex h-full w-full flex-col items-center justify-center px-4 py-12 backdrop-blur-md sm:px-6 sm:py-16 lg:px-8 lg:py-20">
        <h2 className="-mx-4 px-4 pt-4 pb-6 text-xl text-[rgb(72,50,133)] sm:text-2xl xl:text-4xl">
          Become A member of NCC OutLet
        </h2>

        <div className="mx-auto grid max-w-screen-lg grid-cols-1 gap-y-4 gap-x-8 text-center sm:mt-12 sm:text-left md:grid-cols-3">
          <div className="bg-white/10 relative mb-3 rounded-3xl border px-5 py-10 text-left shadow backdrop-blur-lg ">
            <p className="relative text-3xl font-black text-[rgb(72,50,133)] sm:text-3xl">
              Lorem
            </p>
            <p className="relative mt-5 text-gray-600 opacity-70">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Asperiores doloremque vel
            </p>
          </div>

          <div className="bg-white/10 relative mb-3 rounded-3xl border px-5 py-10 text-left shadow backdrop-blur-lg ">
            <p className="relative text-3xl font-black text-[rgb(72,50,133)] sm:text-3xl">
              Lorem
            </p>
            <p className="relative mt-5 text-gray-600 opacity-70">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Asperiores doloremque vel
            </p>
          </div>

          <div className="bg-white/10 relative mb-3 rounded-3xl border px-5 py-10 text-left shadow backdrop-blur-lg ">
            <p className="relative text-3xl font-black text-[rgb(72,50,133)] sm:text-3xl">
              Lorem
            </p>
            <p className="relative mt-5 text-gray-600 opacity-70">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Asperiores doloremque vel
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeMember;
